export const downloadFileByURL = (url: string | undefined) => {
  if (url) {
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    setTimeout(() => link.click(), 3000);
    document.body.removeChild(link);
  }
};
